"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _utils = require("../../../utils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var reviewListConfig = function reviewListConfig(dataSource, onChange) {
  var columns = [{
    title: 'Type',
    dataIndex: 'type',
    key: 'type',
    sorter: true,
    filters: [{
      text: 'Group',
      value: 'group'
    }, {
      text: 'Therapist',
      value: 'therapist'
    }, {
      text: (0, _utils.getRoleName)(_utils.UserRoles.Doctor),
      value: 'physician'
    }],
    filterMultiple: false,
    onFilter: function onFilter(value, record) {
      return value === record.type;
    },
    render: function render(text, record) {
      return /*#__PURE__*/_react.default.createElement("span", null, record.type);
    },
    width: '100px',
    align: 'center'
  }, {
    title: 'Patient Name',
    dataIndex: 'patientName',
    key: 'patientName',
    render: function render(text, record) {
      return /*#__PURE__*/_react.default.createElement("span", null, record.patientName);
    },
    width: '200px',
    align: 'center'
  }, {
    title: 'Therapist or Group Name',
    dataIndex: 'name',
    key: 'name',
    sorter: true,
    render: function render(text, record) {
      return /*#__PURE__*/_react.default.createElement("span", null, record.name);
    },
    width: '200px',
    align: 'center'
  }, {
    title: 'Session Date',
    dataIndex: 'createdAt',
    key: 'createdAt',
    sorter: true,
    render: function render(text, record) {
      return /*#__PURE__*/_react.default.createElement("span", null, (0, _utils.formatDate)(record.createdAt, {
        withTime: true
      }));
    },
    width: '200px'
  }, {
    title: 'Purpose',
    dataIndex: 'purpose',
    key: 'purpose',
    sorter: true,
    render: function render(text, record) {
      return /*#__PURE__*/_react.default.createElement("span", null, record.purpose);
    },
    width: '120px'
  }, {
    title: 'Rating',
    dataIndex: 'rating',
    key: 'rating',
    sorter: true,
    render: function render(text, record) {
      return /*#__PURE__*/_react.default.createElement("span", null, record.stars);
    },
    width: '100px',
    align: 'center'
  }, {
    title: 'Review',
    dataIndex: 'review',
    key: 'review',
    render: function render(text, record) {
      return /*#__PURE__*/_react.default.createElement("span", null, record.review);
    },
    className: 'white-space-initial'
  }, {
    title: 'Allow to Use',
    dataIndex: 'useOfContent',
    key: 'useOfContent',
    render: function render(text, record) {
      return /*#__PURE__*/_react.default.createElement("span", null, record.allowToUse ? 'yes' : 'no');
    },
    align: 'center',
    width: '100px'
  }];
  return {
    columns: columns,
    dataSource: dataSource,
    rowKey: 'id',
    onChange: onChange
  };
};
var _default = reviewListConfig;
exports.default = _default;